<template>
  <v-modal
    title=""
    :show="show"
    @close="$emit('close')"
    size="lg"
    buttonClose="true"
  >
    <ui-spinner v-if="loading.view"></ui-spinner>
    <template v-else>
      <div class="row form-row">
        <div class="col-lg-3">
          <div class="form-group">
            <label for="" class="form-label">Servicio *</label>
            <select v-model="idServicio" class="form-control form-control-sm">
              <option
                v-for="item in containers.servicios"
                :key="item.idServicio"
                :value="item.idServicio"
              >
                {{ item.nombre }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="" class="form-label">Hora *</label>
            <div>
              <UiInputTime
                v-model="time"
                class="form-control form-control-sm"
              />
            </div>
          </div>
          <div class="text-right">
            <button
              class="btn btn-sm btn-outline-success"
              :disabled="loading.crud"
              @click="onNew"
            >
              Nuevo
            </button>
            <button
              class="ml-2 btn btn-sm btn-primary"
              :disabled="loading.crud"
              @click="onSave"
            >
              Guardar
            </button>
          </div>
        </div>
        <div class="col-lg-9">
          <div class="table-responsive">
            <table class="table table-bordered table-sm table-hover">
              <thead class="table-secondary">
                <tr class="text-center align-middle">
                  <th style="width: 80px"></th>
                  <th>Servicio</th>
                  <th>Hora</th>
                  <th>UC</th>
                  <th>UM</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in containers.horas"
                  :key="item.idHotelServicioHoraRecojo"
                  class="align-middle text-center"
                >
                  <td>
                    <template v-if="item.origen != 0">
                      <button
                        class="btn btn-xs btn-icon btn-light-warning"
                        @click="onEdit(item)"
                      >
                        <span class="fa fa-fw fa-pencil-alt"></span>
                      </button>
                      <button
                        class="btn btn-xs btn-icon btn-light-danger ml-2"
                        @click="onDelete(item)"
                      >
                        <span class="fa fa-fw fa-trash-alt"></span>
                      </button>
                    </template>
                  </td>
                  <td>{{ item.nombre }}</td>
                  <td>{{ $formatter("time", item.horaRecojo) }}</td>
                  <td>{{ item.usuarioCreador }}</td>
                  <td>{{ item.usuarioModif }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
  </v-modal>
</template>
<script>
const vModal = () =>
  import(/* webpackChunkName: "ui-modal" */ "@/components/vModal");

const UiInputTime = () => import("@/components/InputTime2");

export default {
  components: {
    vModal,
    UiInputTime,
  },
  props: ["show", "hotel"],
  data() {
    return {
      idServicio: "",
      time: "",
      loading: {
        view: true,
        crud: false,
      },
      containers: {
        id: null,
        horas: [],
        servicios: [],
      },
    };
  },
  async created() {
    let vm = this;

    let response = await vm.axios.get(
      `/mantenimiento/hoteles/${vm.hotel.idHotel}/horas`
    );
    vm.containers.horas = response.data.content.horas;
    vm.containers.servicios = response.data.content.servicios;

    vm.loading.view = false;
  },
  methods: {
    onSave() {
      let vm = this;
      let fd = {
        idServicio: vm.idServicio,
        time: (vm.time || "").trim(),
        _method: "POST",
      };

      if (!(fd.idServicio && fd.time)) {
        return vm.$swal.fire(
          "",
          "Completa los campos obligatorios (*)",
          "warning"
        );
      }

      vm.loading.crud = true;

      let endpoint = `/mantenimiento/hoteles/${vm.hotel.idHotel}/horas`;

      if (vm.containers.id) {
        endpoint = `/mantenimiento/hoteles/${vm.hotel.idHotel}/horas/${vm.containers.id}`;
        fd._method = "PUT";
      }

      vm.axios
        .post(endpoint, fd)
        .then((response) => {
          if (vm.containers.id) {
            let findRow = vm.containers.horas.find(
              (item) => item.idHotelServicioHoraRecojo == vm.containers.id
            );

            findRow.nombre = vm.containers.servicios.find(
              (item) => item.idServicio == fd.idServicio
            ).nombre;
            findRow.idServicio = fd.idServicio;
            findRow.horaRecojo = fd.time;
            findRow.usuarioModif = vm.$store.state.user.codigo;
          } else {
            vm.containers.horas.push({
              idServicio: fd.idServicio,
              nombre: vm.containers.servicios.find(
                (item) => item.idServicio == fd.idServicio
              ).nombre,
              horaRecojo: fd.time,
              idHotelServicioHoraRecojo: response.data.content.id,
              usuarioCreador: vm.$store.state.user.codigo,
            });

            vm.containers.id = response.data.content.id;
          }

          vm.$toast.fire(response.data.message, "", "success");
        })
        .catch((error) => {
          vm.$toast.fire(error.response.data.message, "", "error");
        })
        .finally(() => {
          vm.loading.crud = false;
        });
    },
    onEdit(pItem) {
      this.idServicio = pItem.idServicio;
      this.time = this.$dayjs(pItem.horaRecojo, "HH:mm:ss").format("HH:mm");
      this.containers.id = pItem.idHotelServicioHoraRecojo;
    },
    async onDelete(pItem) {
      let vm = this;
      let response = await vm.$confirm.fire(
        "",
        "¿Seguro que desea eliminar este item?"
      );

      if (response.value) {
        vm.loading.crud = true;

        vm.axios
          .delete(
            `/mantenimiento/hoteles/${vm.hotel.idHotel}/horas/${pItem.idHotelServicioHoraRecojo}`
          )
          .then((response) => {
            let tempRegistros = [...vm.containers.horas];
            vm.containers.horas = tempRegistros.filter(
              (item) =>
                item.idHotelServicioHoraRecojo !=
                pItem.idHotelServicioHoraRecojo
            );
            vm.onNew();
          })
          .catch((error) => {
            vm.$toast.fire(error.response.data.message, "", "error");
          })
          .finally(() => {
            vm.loading.crud = false;
          });
      }
    },
    onNew() {
      let vm = this;
      vm.idServicio = "";
      vm.time = "";
      vm.containers.id = null;
    },
  },
};
</script>
